import styled from 'styled-components'

export const Container = styled.div`
  background-color: var(--white);
  border: 1px solid #E0E0E0;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-height: 248px;
  min-height: 248px;
  padding: 24px;
  max-width: 193px;
  min-width: 193px;

  svg {
    max-height: 29px;
    min-height: 29px;
    max-width: 29px;
    min-width: 29px;
  }

  h4 {
    color: #4F3085;
    font-size: 14px;
    line-height: 16px;
    text-transform: uppercase;
  }

  p {
    color: #1C1C1C;
    line-height: 24px;
  }
`

export const LogosContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`
